import React from 'react';
import { Card } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
// import Image from 'react-bootstrap/Image';

import './HlzTeams.css';
import { hlzTeamTxt } from "../assets/HlzTeamData";

export function HlzTeams() {
  // console.log("get into HlzTeams()");
  return (
    <section id='hlzteams' className='hlzteam-block'>
      {/*
      <div className='title-holder text-center'>
        {/* <h1>Team Member List</h1>
        <h2>---HLZ Team Member---</h2>
        <div className='subtitle fs-3'>Some of our experts</div>
      </div>
      */}

      <Container fluid>
        <h2 className='text-center'>---HLZ Team Member---</h2>
        <h3 className='text-center'>Some of our experts</h3>
        <Row style={{ marginTop: '2%' }}> {
          hlzTeamTxt.map((team, index) => (
            <Col lg={4} style={{ marginBottom: '2%' }}>
              <Card className='border-2' style={{ width: '24.5rem', maxheight: '80vh' }}>
                <Card.Img src={team.image} className='border-1' variant='top' />
                {/* <Card.Img src={team.image} className='border-1' style={{ height: 'auto' }} variant='top' /> */}
                <Card.Text className='text-danger text-center fs-6'>{team.alt}</Card.Text>
                <Card.Body>
                  <Card.Title className='employname text-center fw-bold fs-4'>{team.employname}</Card.Title>
                  <Card.Text className='designation text-center fs-4'>{team.designation}</Card.Text>
                  <Card.Text className='duties text-start'>{team.duties}</Card.Text>
                  {/* <Card.Text className='fs-5 text-start'>{team.duties}</Card.Text> */}
                </Card.Body>
              </Card>
            </ Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default HlzTeams;

      // <Container fluid>
      //   {/* <Container fluid className='d-flex'>
      //   <Row> {
      //     hlzTeamTxt.map(team => {
      //       return (
      //         <Col sm={4} key={team.id}>
      //           <Row className='image'>
      //             {/* <img src={team.image} className='mt-lg-0' style={{ height: '30vh' }} alt={team.alt} />
      //             <Image src={team.image} alt={team.alt} />
      //             <div className='overlay'>
      //               <div className='socials'>
      //                 <ul>
      //                   <li><a href={team.fbLink}><i className='fab fa-facebook-f'></i></a></li>
      //                   <li><a href={team.twitterLink}><i className='fab fa-twitter'></i></a></li>
      //                   <li><a href={team.linkedinLink}><i className='fab fa-linkedin-in'></i></a></li>
      //                 </ul>
      //               </div>
      //             </div>
      //           </Row>
      //           <Row className='content text-center'>
      //             <h3 className='employname fw-bold fs-3'>{team.employname}</h3>
      //             <span className='designation fs-4'>{team.designation}</span>
      //             <p className='fs-5 fw-bold text-start'>{team.text}</p>
      //           </Row>
      //         </Col>
      //       );
      //     })
      //   } </Row>
      // </Container>